import styles from './Documents.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../redux/store'
import HeaderMain from '../../components/header-main/HeaderMain'

import 'react-datepicker/dist/react-datepicker.css'
import DocumentsContracts from './contracts/DocumentsContracts'
import { useEffect } from 'react'
import DocumentsTravelAllowances from './travel-allowances/TravelAllowances'
import Accounts from './accounts/Accounts'
import { appSelector } from '../../redux/selectors/app-selector'
import { setCurrentTab } from '../../redux/reducers/app'
import { getRole } from '../../utils/getRole'

const { isClient } = getRole()
const MobileSettings = () => {
  const dispatch = useDispatch<AppDispatch>()

  const { currentTab } = useSelector(appSelector)
  const title = isClient
    ? [{ key: 2, value: 'Счета' }]
    : [
        { key: 1, value: 'Договора' },
        { key: 2, value: 'Счета' },
        { key: 3, value: 'Командировочные' },
        { key: 4, value: 'Приказы' },
      ]
  return (
    <>
      <div className="dropdown d-block d-sm-none mb-3">
        <select
          value={currentTab}
          onChange={(e) => {
            dispatch(setCurrentTab(Number(e.target.value)))
          }}
        >
          {title?.map((item) => (
            <option key={item.key} value={item.key}>
              {item.value}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}

function Documents() {
  const dispatch = useDispatch<AppDispatch>()

  const { currentTab } = useSelector(appSelector)

  // Инициализация вкладки только один раз при монтировании
  useEffect(() => {
    if (isClient) {
      dispatch(setCurrentTab(2))
      return
    }

    const hash = window.location.hash
    if (hash) {
      const tabFromHash = parseInt(hash.substring(1))
      if ([1, 2, 3, 4].includes(tabFromHash)) {
        dispatch(setCurrentTab(tabFromHash))
        return
      }
    }

    dispatch(setCurrentTab(2))
  }, [dispatch])

  // Обновляем hash при изменении вкладки
  useEffect(() => {
    if (!isClient && currentTab) {
      window.location.hash = currentTab.toString()
    }
  }, [currentTab])

  // Обработка изменения hash в URL
  useEffect(() => {
    if (isClient) return

    const handleHashChange = () => {
      const hash = window.location.hash
      if (hash) {
        const tabFromHash = parseInt(hash.substring(1))
        if ([1, 2, 3, 4].includes(tabFromHash)) {
          dispatch(setCurrentTab(tabFromHash))
        }
      }
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [dispatch])

  return (
    <div className={styles.accountContainer}>
      <div className={styles.accountWideContent}>
        <div className={styles.accountWideContentContainer}>
          <HeaderMain />
          {!isClient && (
            <div
              className={classNames(
                'd-none d-sm-flex flex-wrap align-items-end tabs radio-tabs mb-5',
                styles.radioTabs
              )}
              style={{ textAlign: 'center' }}
            >
              <div className="mt-1 mb-1">
                <input
                  name="setts_radio"
                  id="setts_radio3"
                  type="radio"
                  value={2}
                  checked={currentTab === 2}
                  onChange={() => dispatch(setCurrentTab(2))}
                />
                <label onClick={() => dispatch(setCurrentTab(2))}>Счета</label>
              </div>
              <div className="mt-1 mb-1">
                <input
                  name="setts_radio"
                  id="setts_radio1"
                  type="radio"
                  value={1}
                  checked={currentTab === 1}
                  onChange={() => dispatch(setCurrentTab(1))}
                />
                <label onClick={() => dispatch(setCurrentTab(1))}>
                  Договора
                </label>
              </div>
              <div className="mt-1 mb-1">
                <input
                  name="setts_radio"
                  id="setts_radio3"
                  type="radio"
                  value={3}
                  checked={currentTab === 3}
                  onChange={() => dispatch(setCurrentTab(3))}
                />
                <label onClick={() => dispatch(setCurrentTab(3))}>
                  Командировочные
                </label>
              </div>
              <div className="mt-1 mb-1">
                <input
                  name="setts_radio"
                  id="setts_radio4"
                  type="radio"
                  value={4}
                  checked={currentTab === 4}
                  onChange={() => dispatch(setCurrentTab(4))}
                />
                <label onClick={() => dispatch(setCurrentTab(4))}>
                  Приказы
                </label>
              </div>
            </div>
          )}
          <div>
            <MobileSettings />
          </div>
          {isClient ? (
            // Для клиента показываем только счета
            <Accounts />
          ) : (
            // Для обычных пользователей - все вкладки
            <>
              {currentTab === 1 && <DocumentsContracts />}
              {currentTab === 2 && <Accounts />}
              {currentTab === 3 && <DocumentsTravelAllowances links="3" />}
              {currentTab === 4 && <DocumentsTravelAllowances links="4" />}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Documents
